<div class="container">

  <mat-card class="fade-in" id="vehicle-identity-card">

    <mat-card-title class="accent-color">
      Specifiche veicolo
    </mat-card-title>

    <mat-card-content>

      <div class="row d-flex">
        <div class="col-md-2">
          Descrizione veicolo:
        </div>
        <mat-form-field appearance="outline" class="col-md-10" *ngIf="vehicleVersionSelected.description">
          <input matInput [(ngModel)]="vehicleVersionSelected.description">
        </mat-form-field>
      </div>

      <div class="row d-flex">
        <div class="col-md-2">
          Paese di produzione:
        </div>
        <mat-form-field appearance="outline" class="col-md-2">
          <input matInput [(ngModel)]="vehicleVersionSelected.productionCountry">
        </mat-form-field>
        <div class="col-md-1">
          Targa:
        </div>
        <mat-form-field appearance="outline" class="col-md-2">
          <input matInput [(ngModel)]="vehicleInfo.vehiclePlate">
        </mat-form-field>
        <div class="col-md-1">
          N° telaio:
        </div>
        <mat-form-field appearance="outline" class="col-md-4">
          <input matInput [(ngModel)]="vehicleInfo.chassisCode">
        </mat-form-field>
      </div>

      <div class="row d-flex">
        <div class="col-md-2">
          Data immatricolazione:
        </div>
        <mat-form-field appearance="outline" class="col-md-4">
          <input matInput [(ngModel)]="vehicleInfo.registrationDate">
        </mat-form-field>
        <div class="col-md-2">
          Trasmissione:
        </div>
        <mat-form-field appearance="outline" class="col-md-4">
          <input matInput [(ngModel)]="vehicleVersionSelected.transmission">
        </mat-form-field>
      </div>

      <div class="row d-flex">
        <div class="col-md-2">
          Cilindrata (cm<sup>3</sup>):
        </div>
        <mat-form-field appearance="outline" class="col-md-2">
          <input matInput [(ngModel)]="vehicleVersionSelected.engineCapacity">
        </mat-form-field>
        <div class="col-md-1"></div>
        <div class="col-md-1">
          Cv:
        </div>
        <mat-form-field appearance="outline" class="col-md-2">
          <input matInput [(ngModel)]="vehicleVersionSelected.horsepower">
        </mat-form-field>
        <div class="col-md-1"></div>
        <div class="col-md-1">
          Kw:
        </div>
        <mat-form-field appearance="outline" class="col-md-2">
          <input matInput [(ngModel)]="vehicleVersionSelected.kilowatt">
        </mat-form-field>
      </div>
    </mat-card-content>

    <mat-card-title class="accent-color">
      Quotazioni
    </mat-card-title>

    <mat-card-content>
      <div class="row d-flex">
        <div class="col-md-1">
          Listino nuovo:
        </div>
        <mat-form-field appearance="outline" class="col-md-2">
          <span matSuffix>€</span>
          <input matInput [(ngModel)]="vehicleVersionSelected.quotes.newPriceList">
        </mat-form-field>
        <div class="col-md-1">
          Quotazione:
        </div>
        <mat-form-field appearance="outline" class="col-md-2">
          <span matSuffix>€</span>
          <input matInput [(ngModel)]="vehicleVersionSelected.quotes.sellVehicleQuote">
        </mat-form-field>
        <div class="col-md-1">
          Km teorici:
        </div>
        <mat-form-field appearance="outline" class="col-md-2">
          <input matInput [(ngModel)]="vehicleVersionSelected.quotes.theoreticalKilometers">
        </mat-form-field>
      </div>

    </mat-card-content>

    <mat-card-title class="accent-color">
      Stato d'uso del veicolo
    </mat-card-title>
    <mat-card-content>
      <div class="row d-flex align-items-center">
        <div class="col-md-2"> Stato d'uso carrozzeria </div>
        <mat-slider class="col-md-3" min="1" max="10" step="1" value="1" [(ngModel)]="vehicleVersionSelected.vehicleBodyStatus" #bodySlider> </mat-slider>
        <span class="col-md-1"></span>
        <span> {{ bodySlider.value }} </span>
      </div>

      <div class="row d-flex align-items-center">
        <div class="col-md-2"> Stato d'uso interni </div>
        <mat-slider class="col-md-3" min="1" max="10" step="1" value="1" [(ngModel)]="vehicleVersionSelected.vehicleInternalStatus" #internalSlider> </mat-slider>
        <span class="col-md-1"></span>
        <span> {{ internalSlider.value }} </span>
      </div>

      <div class="row d-flex align-items-center">
        <div class="col-md-2"> Stato d'uso motore </div>
        <mat-slider class="col-md-3" min="1" max="10" step="1" value="1" [(ngModel)]="vehicleVersionSelected.vehicleEngineStatus" #engineSlider> </mat-slider>
        <span class="col-md-1"></span>
        <span> {{ engineSlider.value }} </span>
      </div>

      <div class="row d-flex">
        <div class="col-md-2">
          Km effettivi:
        </div>
        <mat-form-field appearance="outline" class="col-md-2">
          <input matInput [(ngModel)]="vehicleVersionSelected.effectiveKilometers">
        </mat-form-field>
      </div>

      <div class="row d-flex align-items-center">
        <div class="col-md-2">
          Quotazione personalizzata:
        </div>
        <mat-form-field appearance="outline" class="col-md-2">
          <span matSuffix>€</span>
          <input matInput [value]="vehicleVersionSelected.effectiveVehicleQuote" readonly>
        </mat-form-field>
        <button mat-flat-button color="primary">Permuta</button>
      </div>

    </mat-card-content>

    <mat-card-title class="accent-color" *ngIf="vehicleOptionalEquip.length || vehicleSeriesEquip.length">
      Equipaggiamenti
    </mat-card-title>

    <div *ngIf="vehicleSeriesEquip.length" class="mat-h2">
      Di serie
    </div>

    <mat-card-content class="equipments-container">
      <div *ngFor="let equip of vehicleSeriesEquip">
        <mat-checkbox [checked]="true" disabled>
          {{ equip.description }}
        </mat-checkbox>
      </div>
    </mat-card-content>

    <div *ngIf="vehicleOptionalEquip.length" class="mat-h2">
      Optional
    </div>
    <mat-card-content class="equipments-container">
      <div *ngFor="let equip of vehicleOptionalEquip">
        <mat-checkbox (change)="onOptionalEquipChange(equip, $event)">
          {{ equip.description }}
        </mat-checkbox>
      </div>
    </mat-card-content>

    <div id="print-button-container">
      <button mat-raised-button color="primary" (click)="generateVic()">Genera pdf</button>
    </div>

  </mat-card>

</div>
